import React from 'react';

import SingIn from "../components /SignIn";

const SignInPage = () => {

    return (

        <>
            <SingIn/>
        </>
    )
}

export default SignInPage

